import React, { useEffect } from 'react';

import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import Logo from '../components/common/Logo';
import Socials from '../components/about/Socials';
import ContactInput from '../components/about/ContactInput';

import contact from '../data/contact';
import './styles/contact.css';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="page-content">
        <Navbar active="contact" />
        <div className="content-wrapper">
          <div className="contact-logo-container">
            <div className="contact-logo">
              <Logo width={46} />
            </div>
          </div>

          <div className="contact-container">
            <div className="title contact-title">
              {contact.title}
            </div>

            <div className="subtitle contact-subtitle">
              {contact.description}
            </div>
          </div>
        </div>

        <ContactInput />

        <div className="content-wrapper">
          <div className="socials-container">
            <div className="contact-socials">
              <Socials />
            </div>
          </div>

          <div className="page-footer">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
